import { Guid } from 'guid-typescript'

import { ReplicatorItem } from './types'

export function createReplicatorItem(value: any): ReplicatorItem {
  return { id: Guid.create().toString(), value }
}

export function processReplicatorItemsForOutput(replicatorItems: Array<ReplicatorItem>): Array<any> {
  return replicatorItems.map((replicatorItem: ReplicatorItem) => replicatorItem.value)
}
